import AboutPage from '../../src/client/pages/about';

export default AboutPage;
